import angular from 'angular';

angular.module('commonServices').factory('appUrls', [
  '$window',
  function($window) {
    return $window.backendUrls || {};
  },
]);
